import { Result } from '@blade/std-lib'
import { favoriteMetasModelByNetwork } from '@root/entities/pair/atoms/reatom-favorite-metas'
import { reatomRequest } from '@root/shared/lib'

import { setFavoritePairsOrderRequestAction } from './favorite-requests'

export const reatomSetFavoritesOrder = () => {
  const setFavoritePairsOrderRequestState = reatomRequest({
    execAction: setFavoritePairsOrderRequestAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'setFavoritePairsOrderRequestState',
    onResult: (ctx, result, [args]) => {
      if (Result.isSuccess(result)) {
        favoriteMetasModelByNetwork[args.network].updateFromDtos(
          ctx,
          result.success,
        )
      }
    },
  })

  return { setFavoritePairsOrderRequestState }
}
